import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
  size?: 'sm' | 'md' | 'lg';
}

export default function VideoCard({ video, size = 'md' }: VideoCardProps) {
  const imgHeight = size === 'sm' ? 'h-56' : size === 'lg' ? 'h-72' : 'h-64';

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block"
    >
      <div className={`relative ${imgHeight} rounded-lg overflow-hidden bg-background-200`}>
        <img
          src={video.image}
          alt={video.title}
          title={`${video.title} - 西瓜视频免费在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <div className="flex items-center justify-center">
              <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          {video.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-background-50">
              新
            </span>
          )}
          {video.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium rounded bg-primary-500 text-background-50">
              热播
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded bg-black/60 text-background-50">
          {video.rating}
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {video.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{video.category}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{video.year}</span>
        </div>
      </div>
    </Link>
  );
}